export setLoading = (bool) ->
  type: 'SET_LOADING'
  payload:
    data: bool

export setNode = (node) ->
  type: 'SET_NODE'
  payload:
    data: node